export type AuditTags = {
  workflowId?: string
  mapId?: string
}

export function buildAuditTags(tags: AuditTags) {
  const urlTags = {} as Record<string, string>
  if (tags.workflowId) {
    urlTags[`tag-workflowId`] = tags.workflowId
  }
  if (tags.mapId) {
    urlTags[`tag-mapId`] = tags.mapId
  }
  return urlTags
}
